// Echarts图表字体、间距自适应
export const fitChartSize = (size, defaultWidth = 1920) => {
  let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  if (!clientWidth) return size
  let scale = clientWidth / defaultWidth
  return Number((size * scale).toFixed(3))
}

// 单位转换
export const evaluatorNum = (total, decimal = 1) => {
  const num = Number(total)
  if (num >= 10000) return parseFloat((num / 10000).toFixed(decimal))
  return num % 1 !== 0 ? parseFloat(num.toFixed(decimal)) : parseInt(num)
}

export const evaluatorUnit = (total, unit) => {
  const num = Number(total)
  return num >= 10000 ? `万${unit}` : unit
}

// 判断count-to是否需要显示小数位
export const countToDecimal = value => {
  const num = evaluatorNum(value)
  return num % 1 !== 0 ? 1 : 0
}
